var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('product-sale-view',_vm._g(_vm._b({attrs:{"is-simple":_vm.isSimple}},'product-sale-view',_vm.productProps,false),_vm.productListeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }